import styled from '@emotion/styled';
import { Text } from '../text';
/**
 * Component that is used as an ERROR text for form fields.
 */
export const Error = styled(Text) `
  color: ${({ theme }) => theme.input.errorColor};
`;
Error.defaultProps = {
    as: 'span',
    variant: 'xs',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9lcnJvci9FcnJvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0saUJBQWlCLENBQUM7QUFDckMsT0FBTyxFQUFFLElBQUksRUFBYSxNQUFNLFNBQVMsQ0FBQztBQUkxQzs7R0FFRztBQUVILE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQVk7V0FDbEMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLFVBQVU7Q0FDL0MsQ0FBQztBQUVGLEtBQUssQ0FBQyxZQUFZLEdBQUc7SUFDbkIsRUFBRSxFQUFFLE1BQU07SUFDVixPQUFPLEVBQUUsSUFBSTtDQUNkLENBQUMifQ==